"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutWordBoundsPrevGroupSeparator = exports.LayoutWordBoundsNextGroupSeparator = exports.LayoutWordBoundsGroupSeparator = void 0;
var tslib_1 = require("tslib");
var flag_1 = require("@devexpress/utils/lib/class/flag");
var layout_word_bounds_1 = require("./layout-word-bounds");
var LayoutWordBoundsGroupSeparator = (function () {
    function LayoutWordBoundsGroupSeparator() {
        this.isAnyGroupSet = false;
    }
    LayoutWordBoundsGroupSeparator.prototype.applyMask = function (mask) {
        if (!this.isAnyGroupSet) {
            this.isAnyGroupSet = true;
            this.whileNoOneGroupSet(mask);
            return false;
        }
        if (mask == this.ignoredGroupMask)
            return false;
        this.ignoredGroupMask = layout_word_bounds_1.WordGroupMask.NoOne;
        if (this.mask.get(layout_word_bounds_1.WordGroupMask.DiffersFromAll))
            return true;
        this.mask.set(mask, true);
        if (this.prevMask && this.prevMask.getValue() != this.mask.getValue())
            return true;
        this.prevMask = this.mask.clone();
        return false;
    };
    return LayoutWordBoundsGroupSeparator;
}());
exports.LayoutWordBoundsGroupSeparator = LayoutWordBoundsGroupSeparator;
var LayoutWordBoundsNextGroupSeparator = (function (_super) {
    tslib_1.__extends(LayoutWordBoundsNextGroupSeparator, _super);
    function LayoutWordBoundsNextGroupSeparator(isJoinSpacesOnEndWord) {
        var _this = _super.call(this) || this;
        _this.initGroup = isJoinSpacesOnEndWord ? layout_word_bounds_1.WordGroupMask.Space : layout_word_bounds_1.WordGroupMask.NoOne;
        return _this;
    }
    LayoutWordBoundsNextGroupSeparator.prototype.whileNoOneGroupSet = function (mask) {
        if (mask == layout_word_bounds_1.WordGroupMask.DiffersFromAll) {
            this.mask = new flag_1.Flag(mask);
            return;
        }
        this.ignoredGroupMask = mask;
        this.prevMask = new flag_1.Flag(this.initGroup);
        this.mask = new flag_1.Flag(this.initGroup);
    };
    return LayoutWordBoundsNextGroupSeparator;
}(LayoutWordBoundsGroupSeparator));
exports.LayoutWordBoundsNextGroupSeparator = LayoutWordBoundsNextGroupSeparator;
var LayoutWordBoundsPrevGroupSeparator = (function (_super) {
    tslib_1.__extends(LayoutWordBoundsPrevGroupSeparator, _super);
    function LayoutWordBoundsPrevGroupSeparator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LayoutWordBoundsPrevGroupSeparator.prototype.whileNoOneGroupSet = function (mask) {
        if (mask == layout_word_bounds_1.WordGroupMask.Space) {
            this.ignoredGroupMask = layout_word_bounds_1.WordGroupMask.Space;
            this.mask = new flag_1.Flag(layout_word_bounds_1.WordGroupMask.NoOne);
            this.prevMask = null;
        }
        else {
            this.mask = new flag_1.Flag(mask);
            this.prevMask = this.mask.clone();
        }
    };
    return LayoutWordBoundsPrevGroupSeparator;
}(LayoutWordBoundsGroupSeparator));
exports.LayoutWordBoundsPrevGroupSeparator = LayoutWordBoundsPrevGroupSeparator;
